import { ref } from 'vue'

import { defineStore } from 'pinia'

export const useLiveChatStore = defineStore('live-chat', () => {
  const startConversationWith = ref(null)
  const newMessagesInChat = ref(null)
  const displayChat = ref(false)

  function initConversationWith(data) {
    startConversationWith.value = data
  }

  function setNewMessagesInChat(data) {
    newMessagesInChat.value = data
  }

  function toggleDisplayChat() {
    displayChat.value = !displayChat.value
  }

  return {
    startConversationWith,
    newMessagesInChat,
    displayChat,

    //functions
    initConversationWith,
    setNewMessagesInChat,
    toggleDisplayChat
  }
})
